import React, { Component } from 'react';
import { Chart, Geom, Axis, Coord, Tooltip } from 'bizcharts';
import PropTypes from 'prop-types';
import { DataView } from '@antv/data-set';

// 渲染雷达图组件

export default class RandarChart extends Component {
  // 参数
  static propTypes = {
    data: PropTypes.array,
    examId: PropTypes.number, // true: 托福TOEFL; false: 雅思IELTS;
    width: PropTypes.number,
    height: PropTypes.number,
    rotate: PropTypes.number,
    padding: PropTypes.array,
  };
  // 参数
  static defaultProps = {
    data: [
      { name: 'Reading' },
      { name: 'Listening' },
      { name: 'Speaking' },
      { name: 'Writing' },
    ],
    examId: 1,
    width: 250,
    height: 250,
    rotate: 135,
    padding: [22, 25, 15, 5],
  };
/* eslint-disable */
  render() {
    const { data, examId, width, height, rotate, padding } = this.props;
    data.map(item => {
      const dividend = examId === 1 ? 30 : 9;
      item.score = Math.round(item.accuracy * dividend * 2) / 2;
    });
    const dv = new DataView().source(data);
    dv.transform({
      type: 'fold',
      fields: 'score', // 展开字段集
      key: 'user', // key字段
      value: 'grade', // value字段
    });
    const cols = {
      grade: {
        min: 0,
        max: examId === 1 ? 30 : 9,
        tickCount: 6, // 定义坐标轴刻度线的条数，默认为 5
      },
    };
    return (
      <Chart width={width} height={height} data={dv} padding={padding} scale={cols}>
        <Coord type="polar" radius={0.8} rotate={rotate} />
        <Axis
          name="name"
          label={
            {
              offset: 8,
              textStyle: {
                fontFamily: 'PingFangSC-Regular',
                fill: '#fff', // 文本的颜色
                fontSize: '12', // 文本大小
                fontWeight: 400,
                lineHeight: '10',
                rotate: 0,
              },
            }
          }
          line={{
            stroke: 'rgba(256,256,256,0)', // 坐标轴线的颜色
            strokeOpacity: '0.5', // 坐标轴线的透明度，数值范围为 0 - 1
            lineWidth: '0.1', // 设置坐标轴线的粗细
            opacity: 0.2,
          }}
          tickLine={null}
          grid={{
            lineStyle: {
              stroke: 'rgba(256,256,256,0.2)', // 网格线的颜色
              lineDash: null,
            },
            hideFirstLine: true,
          }}
        />
        <Axis
          name="grade"
          line={{
            stroke: 'rgba(256,256,256,0)', // 坐标轴线的颜色
            strokeOpacity: '0.5', // 坐标轴线的透明度，数值范围为 0 - 1
            lineWidth: '0.1', // 设置坐标轴线的粗细
            opacity: 0.2,
          }}
          label={
            {
              textStyle: {
                fontSize: '0', // 文本大小
              },
            }
          }
          tickLine={null}
          grid={{
          type: 'point',
          lineStyle: {
            stroke: 'rgba(256,256,256,0)', // 网格线的颜色
          },
          hideFirstLine: true,
          }}
        />
        <Geom
          type="path"
          position="name*grade"
          color="#FFD123"
          animate={{
            appear: {
            animation: 'zoomIn',
            delay: 100, // 动画延迟执行时间
            duration: 400, // 动画执行时间
            },
          }}
        />
        <Tooltip />
        <Geom
          type="point"
          position="name*grade"
          color="#FFD123"
          shape="circle"
          size={3}
          style={{
            stroke: '#FFE47D',
            lineWidth: 2,
            fillOpacity: 0.3,
          }}
        />
      </Chart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/radar_chart/index.js